"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPCMethods = void 0;
exports.JSONRPCMethods = {
    bouncer: {
        users: {
            getMyProfile: 'bouncer.users.getMyProfile',
            updateMyProfile: 'bouncer.users.updateMyProfile'
        },
        rooms: {
            join: 'bouncer.rooms.join',
            getUserRooms: 'boucer.rooms.getUserRooms',
            getPendingRooms: 'bouncer.rooms.getPendingRooms'
        }
    },
    room: {
        message: {
            write: 'room.message.write',
            read: 'room.message.read'
        },
        section: {
            updateProfile: 'room.section.updateProfile',
            users: 'room.section.getUsers',
            join: 'room.section.join'
        }
    }
};
//# sourceMappingURL=JSONRPCMethods.enum.js.map